export default "__VITE_ASSET__a4159554__"